module.exports = __webpack_public_path__ + "img/wechat.c5e4827d.svg";